import { useState } from 'react';
import LoadingSpinner from "./LoadingSpinner";
import './Ocr.css';

const OCR = () => {
    const [imageSrc, setImageSrc] = useState();
    const [b64img, setB64img] = useState();
    // const [buttonStateDisabled, setButtonStateDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // alert("Default image ready")
    // setB64img("http://www.rcdrilling.com/wp-content/uploads/2013/12/default_image_01-1024x1024-570x321.png");

    const getB64Image = async () => {
        if(!imageSrc || imageSrc === null) {
            alert("Link can't be empty");
            return;
        }

        const imageSrcParts = imageSrc.split('.');
        const lastPart = imageSrcParts[imageSrcParts.length - 1];

        switch(lastPart) {
            case "png":
            case "jpg":
            case "jpeg": break;
            default : alert("Invalid URL!\nOnly .png, .jpg & .jpeg image are allowed"); return;
        }

        // setButtonStateDisabled(true)
        setIsLoading(true)
        // "http://localhost:1323/ocr?imageurl=" + imageSrc
        const response = await fetch(
            "https://ghostbyte.xyz/goserverocr?imageurl=" + imageSrc
        ).then((result) => {
            return result.json();
        }).then((text) => {
            // console.log(text['image'].replace(/["]+/g, ''))

            if(text['image'].includes("Image processing error")) {
                alert("Unable to process the image for now. We will improve the OCR functions gradually.")
                setIsLoading(false)
                return
            }

            setB64img('data:image/jpg;base64,' + text['image'].replace(/["]+/g, ''));
            // setButtonStateDisabled(false)
            setIsLoading(false)
        })
        .catch(err => {
            // console.log(err)
            alert("Please enter a valid image URL");
            // setButtonStateDisabled(false)
            setIsLoading(false)
        })
    }
    
    const renderOCRImage = (
        <div>
            <img
                src={b64img}
                sizes="(max-width: 300px) 300px, (max-width: 768px) 768px, 1280px"
                height="576" width="720"/>
        </div>
    );


    return (
        <div className="ocr">
            <div className='ocrbody innerColor'>
                <h2 className='underline'>Optical Character Recognition Web App</h2>
                <p>
                    This is an OCR research project which utilizes the following technology stack:
                    <ul>
                        <li>Python</li>
                        <li>Golang</li>
                        <li>OpenCV</li>
                        <li>EasyOCR</li>
                        <li>PyTorch</li>
                    </ul>
                </p>
                <h5>Please input image URL in the text box & click on the process OCR button.</h5>
                <h6>
                    Supported format: PNG/JPG/JPEG<br/>
                    example url:
                    <ul>
                        <li>https://practice.typekit.com/social/l002-social.jpg</li>
                        <li>https://i.stack.imgur.com/i1Abv.png</li>
                    </ul>
                     
                    
                </h6>
                <input disabled={isLoading} value={imageSrc} onChange={e => setImageSrc(e.target.value)} size="66"></input>
                <button disabled={isLoading} onClick={getB64Image}>Process OCR</button>
                <br/>
                <br/>
                {isLoading ? <LoadingSpinner /> : renderOCRImage}
            </div>
            
        </div>
    );
}

export default OCR